import { GET_LIST } from "../../types/ActionTypes";
import { PatientPointDataListActionType } from "./ActionTypes";
import { PatientDataDetailsRes } from "./Model";

export const getPatientDataPointListAction = (
  patientDemographicsDetails: PatientDataDetailsRes,
  pageCount: number
): PatientPointDataListActionType => {
  return {
    type: GET_LIST,
    payload: patientDemographicsDetails,
    pageCount: pageCount,
  };
};
